import React, { useState } from "react";
import AdminLogin from "./AdminLogin";
import AdminDashboardLocal from "./AdminDashboardLocal";
import { getAdminToken, clearAdminToken } from "./adminApi";

// Thin wrapper: shows the real login form until a valid admin JWT is present
// (adminApi.adminFetch clears it automatically on a 401), then the dashboard.
export default function MasterAdmin() {
  const [loggedIn, setLoggedIn] = useState(() => !!getAdminToken());

  const handleLogout = () => {
    clearAdminToken();
    setLoggedIn(false);
  };

  if (!loggedIn) return <AdminLogin onLogin={() => setLoggedIn(true)} />;

  return <AdminDashboardLocal onLogout={handleLogout} />;
}
